import { Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps } from '@mantine/core'

import useStyles from './index.styles'

type Props = {
  heading?: string
  description?: string
  onClick?: () => void
} & BoxProps

export const SuggestMessage = ({
  heading,
  description,
  styles,
  classNames,
  className,
  onClick,
  ...boxProps
}: Props) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'AIChatBotWidget__SuggestMessage',
    styles,
    classNames,
  })
  return (
    <Box
      className={cx(classes.root, className)}
      {...boxProps}
      onClick={onClick}
    >
      {heading && (
        <Text className={classes.heading} size="s2">
          {heading}
        </Text>
      )}
      {description && (
        <Text className={classes.description} size="p3">
          {description}
        </Text>
      )}
    </Box>
  )
}
